import { TransProps, useTranslation } from 'react-i18next';
import * as Yup from 'yup';

import { postalCodeRegexp, phoneRegexp, emailRegexp } from '../../../constants';
import { DeliveryCompanyOrderFormData } from '../../../interfaces';

export const useDeliveryCompanyOrderFormValidation: () => Yup.SchemaOf<DeliveryCompanyOrderFormData>
= (): Yup.SchemaOf<DeliveryCompanyOrderFormData> => {
  const { t }: TransProps<never> = useTranslation();

  return Yup.object().shape({
    firstName: Yup.string()
      .max(64, t('onarte.common.validations.maxLength'))
      .required(t('onarte.common.requiredField')),
    lastName: Yup.string()
      .max(128, t('onarte.common.validations.maxLength'))
      .required(t('onarte.common.requiredField')),
    phone: Yup.string()
      .required(t('onarte.common.requiredField'))
      .matches(phoneRegexp, t('onarte.common.validations.phone')),
    email: Yup.string()
      .max(128, t('onarte.common.validations.maxLength'))
      .required(t('onarte.common.requiredField'))
      .matches(emailRegexp, t('onarte.common.validations.email')),
    street: Yup.string()
      .max(128, t('onarte.common.validations.maxLength'))
      .required(t('onarte.common.requiredField')),
    houseNumber: Yup.string()
      .max(8, t('onarte.common.validations.maxLength'))
      .required(t('onarte.common.requiredField')),
    apartmentNumber: Yup.string()
      .max(8, t('onarte.common.validations.maxLength'))
      .optional()
      .nullable(),
    postalCode: Yup.string()
      .required(t('onarte.common.requiredField'))
      .matches(postalCodeRegexp, t('onarte.common.validations.postalCode')),
    city: Yup.string()
      .max(128, t('onarte.common.validations.maxLength'))
      .required(t('onarte.common.requiredField')),
    country: Yup.string()
      .max(64, t('onarte.common.validations.maxLength'))
      .required(t('onarte.common.requiredField')),
  });
};
